module.exports = __webpack_public_path__ + "static/media/FoyerCoffee.fea901e0.jpg";